import { BigNumber } from '@ethersproject/bignumber';
import { useQuery } from '@tanstack/react-query';
import { useVenoSDK } from '@ui/providers/VenoSDKProvider';
import type { LiquidityStrategyDepositToken } from '@ui/utils/strategy';

export const useStrategyDepositTransactionFee = (
  token: LiquidityStrategyDepositToken,
) => {
  const sdk = useVenoSDK();

  const getFee = async () => {
    if (token !== 'cro') return BigNumber.from(0);
    return sdk.CroDelegator.estimateGasForDeposit();
  };

  const { data: stakeFee } = useQuery(
    ['useStrategyDepositTransactionFee', token],
    getFee,
  );

  return stakeFee;
};
